<template>
  <div class="form-dataset-filter">
    <div class="form-dataset-filter__header">
      <div class="form-dataset-filter__filter-wrapper">
        <b-form-input
          v-model="optionFilter"
          class="form-dataset-filter__filter-input mb-2"
          size="lg"
          placeholder="Digite um nome para filtrar" />
        <div class="form-dataset-filter__filter-text-wrapper">
          <span v-if="!reachedSelectionLimit" class="form-dataset-filter__filter-description">
            Selecione até {{ maxItemsToSelected }} itens
          </span>
          <span
            v-else
            class="form-dataset-filter__filter-description text-danger font-weight-bold">
            Limite de itens atingido
          </span>
          <span
            v-if="selectedOptions.length"
            @keydown.enter="unselectAll"
            @click="unselectAll"
            class="form-dataset-filter__filter-clear">
            Limpar
          </span>
        </div>
      </div>
      <div v-if="selectedOptions.length" class="form-dataset-filter__chips-wrapper">
        <div
          v-for="(item, index) in selectedOptions"
          :key="index"
          class="form-dataset-filter__chips-item"
          :title="item.label">
          <span>{{ item.label }}</span>
          <button @click="unselectChip(item)">X</button>
        </div>
      </div>
    </div>
    <div class="form-dataset-filter__content">
      <div class="form-dataset-filter__list-wrapper">
        <checkbox-group
          name="datasets-options"
          v-model="selectedOptions"
          :options="checkboxGroupOptions"
          :max-items="maxItemsToSelected"
          :filter="filterOptions" />
      </div>
    </div>
    <div class="form-dataset-filter__footer">
      <button
        class="form-dataset-filter__btn form-dataset-filter__btn-flat"
        @click="$emit('cancel')">Cancelar</button>
      <button
        class="form-dataset-filter__btn form-dataset-filter__btn-confirm"
        :disabled="!selectedOptions.length"
        @click="applySelection">
        Aplicar
      </button>
    </div>
  </div>
</template>

<script>
import CheckboxGroup from '@/components/CheckboxGroup/CheckboxGroup.vue';

export default {
  name: 'form-dataset-filter',
  components: {
    'checkbox-group': CheckboxGroup,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    activeDatasetOptions: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    optionFilter: '',
    maxItemsToSelected: 5,
    selectedOptions: [],
    checkboxGroupOptions: [],
  }),
  computed: {
    reachedSelectionLimit() {
      return !(this.selectedOptions.length < this.maxItemsToSelected);
    },
  },
  watch: {
    selectedOptions() {
      this.checkboxGroupOptions = this.checkboxGroupOptions.map((option) => ({
        ...option,
        checked: this.selectedOptions.includes(option.value),
      }));
    },
  },
  created() {
    // cria um novo array para que o objeto original não seja modificado pelo checkbox-group
    this.selectedOptions = [...this.activeDatasetOptions];

    this.checkboxGroupOptions = this.options.map((option) => ({
      value: option,
      label: option.label,
      checked: this.selectedOptions.includes(option),
    }));
  },
  methods: {
    applySelection() {
      this.$emit('confirm', this.selectedOptions);
    },
    unselectAll() {
      this.selectedOptions = [];
    },
    unselectChip(item) {
      this.selectedOptions = this.selectedOptions.filter((selectedOpt) => selectedOpt !== item);
    },
    filterOptions(option) {
      if (!this.optionFilter) return true;

      const normalizedFilterString = this.repalceAccentedCharacters(this.optionFilter);
      const normalizedItemLabel = this.repalceAccentedCharacters(option.label);
      const filterRegex = new RegExp(`.*?${normalizedFilterString}.*?`, 'i');
      return filterRegex.test(normalizedItemLabel);
    },
    repalceAccentedCharacters(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
  },
};
</script>

<style lang="scss" scoped>
$primary-light: #0F9D8A;

.form-dataset-filter {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  .form-dataset-filter__header {
    padding: .75rem;
    padding-bottom: .25rem;
    border-bottom: 1px solid #707070;
    .form-dataset-filter__filter-wrapper {
      .form-dataset-filter__filter-input {
        font-size: .875rem;
        height: 48px;
      }
      .form-dataset-filter__filter-text-wrapper {
        display: flex;
        justify-content: space-between;
        font-size: .75rem;
        .form-dataset-filter__filter-description {
          margin-bottom: .25rem;
        }
        .form-dataset-filter__filter-clear {
          color: $primary-light;
          font-weight: 600;
          cursor: pointer;
        }
      }
    }
    .form-dataset-filter__chips-wrapper {
      display: flex;
      flex-wrap: wrap;
      font-size: .75rem;
      color: $primary;
      font-weight: 600;
      margin-top: .25rem;
      .form-dataset-filter__chips-item {
        display: inline-flex;
        padding: .3rem 1rem;
        background-color: rgba(10, 100, 88, .08);
        border-radius: 14px;
        margin: 0 .875rem .75rem 0;
        max-width: 120px;
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        button {
          background-color: transparent;
          border: none;
          padding: 0;
          margin-left: .5rem;
          color: $primary;
          font-weight: 600;
        }
      }
    }
  }
  .form-dataset-filter__content {
    flex-grow: 1;
    overflow: auto;
    min-height: 100px;
    .form-dataset-filter__list-wrapper {
      padding: .75rem;
      height: 100%;
      overflow-y: scroll;
    }
  }

  .form-dataset-filter__footer {
    flex-shrink: 0;
    overflow: hidden;
    padding: .75rem;
    border-top: 1px solid #707070;
  }

  .form-dataset-filter__btn {
    height: 48px;
    width: 50%;
    border-radius: 8px;
    &-flat {
      font-weight: 600;
      background-color: transparent;
      border: transparent;
      color: $primary;
    }
    &-confirm {
      text-transform: none;
      color: $white;
      &:disabled {
        background-color: #A4A4A4;
        border: #A4A4A4;
      }
      &:not(:disabled) {
        font-weight: 600;
        background-color: $primary-light;
        border: $primary-light;
      }
    }
  }
}
</style>
